import { Injectable } from "@angular/core";
import CryptoJS from "crypto-js";
import { Block } from "../../models/block.interface";
import { UserProvider } from "../user/user";
import { Environment } from "../../environment/environment";
import { Storage } from "@ionic/storage";
import { AlertController } from "ionic-angular";

@Injectable()
export class ValidateProvider {
  validHashes:boolean;
  chainValid:boolean;
  blocks:Block[];
  constructor(public userservice: UserProvider, public storage: Storage,
  public alertCtrl: AlertController) {
    
  }

  validateHashes(){
    this.validHashes=true;
    for (let x = 1; x < this.blocks.length; x++) {
      let tempBlock = this.blocks[x];
      let tempHash = CryptoJS.SHA256(
        tempBlock.barcode +
          tempBlock.count +
          tempBlock.dates +
          tempBlock.details +
          tempBlock.difficulty +
          tempBlock.hashedCodes +
          tempBlock.img +
          tempBlock.lats +
          tempBlock.longs +
          tempBlock.name +
          tempBlock.nonce +
          tempBlock.prevHash +
          tempBlock.private +
          tempBlock.users
      ).toString(CryptoJS.enc.Hex);
      if (tempHash != tempBlock.hash) {
        this.validHashes = false;
        this.chainValid = false;
      }
    }
  }

  validateBlockchain(): Promise<any>{
    return new Promise((resolve) => {
      this.userservice.getBlockchain().then(val => {
        this.blocks = val.blocks;
        this.chainValid = true;
        this.validateHashes();
        let block0 = this.blocks[0];
        let genesisBlock = Environment. genesisBlock;
        if (
          block0.count != genesisBlock.count ||
          block0.hash != genesisBlock.hash ||
          block0.dates[0] != genesisBlock.dates[0]
        ) {
          this.chainValid = false;
        }
        this.storage.get("blocks").then(val => {
          if (val.length > this.blocks.length) {
            this.chainValid = false;
          }
        });
        for (let x = this.blocks.length - 1; x > 1; x--) {
          let prevHash = this.blocks[x - 1].hash;
          let currentHash = this.blocks[x].prevHash;
          if (currentHash != prevHash) {
            this.chainValid = false;
  
            break;
          } else if (this.blocks[x].count - 1 != this.blocks[x - 1].count) {
            this.chainValid = false;
            break;
          } else if (
            typeof this.blocks[x].barcode != "string" ||
            typeof this.blocks[x].count != "number" ||
            typeof this.blocks[x].dates != "object" ||
            typeof this.blocks[x].details != "string" ||
            typeof this.blocks[x].difficulty != "number" ||
            typeof this.blocks[x].hash != "string" ||
            typeof this.blocks[x].hashedCodes != "string" ||
            typeof this.blocks[x].img != "string" ||
            typeof this.blocks[x].lats != "object" ||
            typeof this.blocks[x].longs != "object" ||
            typeof this.blocks[x].name != "string" ||
            typeof this.blocks[x].nonce != "number" ||
            typeof this.blocks[x].prevHash != "string" ||
            typeof this.blocks[x].private != "boolean" ||
            typeof this.blocks[x].users != "object"
          ) {
            this.chainValid = false;
            break;
          } else if (!this.validHashes) {
            this.chainValid = false;
            break;
          }
        }
  
        if (this.chainValid) {
          resolve(true);
        } else {
          let alert = this.alertCtrl.create({
            enableBackdropDismiss: false,
            title: "Blockchain is corrupted!",
            message:
              "All blockchain functions have been disabled until blockchain is fixed.",
            buttons: [
              {
                text: "Dismiss",
                handler: () => {
                  this.validateBlockchain();
                }
              },
            ]
          });
          alert.present();
          resolve(false);
        }
        this.blocks = val.blocks.reverse();
      });
    })
    
  }
}



// WEBPACK FOOTER //
// ./src/providers/validate/validate.ts